import {createSlice} from '@reduxjs/toolkit';



export const icoSlice = createSlice({
   name : 'ico',
    initialState:{
        ico:null,
        contributors:null,
    },
    reducers:{
        setIcoData:(state,action)=>{
            state.ico = action.payload
        },
        setContributors:(state,action)=>{
            state.contributors = action.payload
        },
    }
})





